// toggle text when checked / unchecked radio box
window.toggleRadioBox = (target) => {
    const textActive = "text-primary";
    const textInactive = "text-muted";
    const radios = document.querySelectorAll(`[name='${target.name}'`);

    radios.forEach((el) => {
        let label = document.querySelector(`[for=${el.id}`);
        let removeTextStyle =
            el.value !== target.value ? textActive : textInactive;
        let addTextStyle =
            el.value !== target.value ? textInactive : textActive;

        label.classList.remove(removeTextStyle);
        label.classList.add(addTextStyle);
    });
};

// change text, when collapse has shown / hidden
window.toggleCollapseLabel = (target) => {
    const href = target.getAttribute("href");

    if (!href) return;

    const collapse = document.getElementById(href.substring(1));

    if (!collapse) return;

    const expanded = target.getAttribute("aria-expanded");
    const show = target.getAttribute("data-toggle-show");
    const hide = target.getAttribute("data-toggle-hide");

    target.textContent = (expanded === 'true' ? hide : show);

};

window.loadingButton = (e, message) => {
    e.innerHTML =
        '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' +
        message;
    e.setAttribute("disabled", true);
};

window.togglePassword = (e) => {
    let type = e.parentNode.querySelector(".password").getAttribute("type");
    if (type === "password") {
        e.parentNode.querySelector(".password").setAttribute("type", "text");
        e.querySelector("i").classList.remove("fe-eye-off");
        e.querySelector("i").classList.add("fe-eye");
    } else if (type === "text") {
        e.parentNode
            .querySelector(".password")
            .setAttribute("type", "password");
        e.querySelector("i").classList.remove("fe-eye");
        e.querySelector("i").classList.add("fe-eye-off");
    }
};

window.removeValidate = (e) => {
    document.querySelector("form").classList.remove("was-validated");
    e.classList.remove("is-invalid");
};

window.loadingPage = () => {
    const loadingPage = document.getElementById('loading-page');
    loadingPage.classList.remove('fade-loading');
};

window.loadingPageClose = () => {
    const loadingPage = document.getElementById('loading-page');
    loadingPage.classList.add('fade-loading');
};

window.openModal = (modalId, closeModalId) => {
    if (closeModalId) {
        document.getElementById(closeModalId).classList.remove("show");
        document.getElementById(closeModalId).style.display = "none";
        document.getElementsByClassName("modal-backdrop")[0].remove();
        const closeModal = new Modal(document.getElementById(closeModalId), {
            keyboard: true,
        });
        closeModal.hide();
    }
    const modal = new Modal(document.getElementById(modalId), {
        keyboard: true,
    });
    modal.show();
};

window.closeModal = (closeModalId) => {
    document.getElementById(closeModalId).classList.remove("show");
    document.getElementById(closeModalId).style.display = "none";
    document.getElementsByClassName("modal-backdrop")[0].remove();
    const closeModal = new Modal(document.getElementById(closeModalId), {
        keyboard: true,
    });
    closeModal.hide();    
};

window.validateChangePasswordModal = () => {
    const oldPassword = document.getElementById("oldPassword").value;
    const newPassword = document.getElementById("newPassword").value;
    const confirmPassword = document.getElementById("confirmPassword").value;
    let xhr = new XMLHttpRequest();
    let formData = new FormData();
    formData.append("oldPassword", oldPassword);
    formData.append("newPassword", newPassword);
    formData.append("confirmPassword", confirmPassword);
    xhr.onreadystatechange = function (data) {
        if (xhr.readyState === 4) {
            const response = JSON.parse(xhr.responseText);
            if (response.errors) {
                if (response.errors.oldPassword) {
                    document
                        .getElementById("oldPassword")
                        .classList.add("is-invalid");
                    document
                        .getElementById("oldPassword")
                        .parentNode.querySelector(
                            ".invalid-feedback"
                        ).innerText = response.errors.oldPassword;
                }

                if (response.errors.newPassword) {
                    document
                        .getElementById("newPassword")
                        .classList.add("is-invalid");
                    document
                        .getElementById("newPassword")
                        .parentNode.querySelector(
                            ".invalid-feedback"
                        ).innerText = response.errors.newPassword;
                }

                if (response.errors.confirmPassword) {
                    document
                        .getElementById("confirmPassword")
                        .classList.add("is-invalid");
                    document
                        .getElementById("confirmPassword")
                        .parentNode.querySelector(
                            ".invalid-feedback"
                        ).innerText = response.errors.confirmPassword;
                }
            } else {
                window.sendOTP();
                window.openModal("verifyOTPModal", "changePasswordModal");
            }
            window.loadingPageClose();
        }
    };
    xhr.open("POST", "/me/validate-change-password-modal/");
    xhr.send(formData);
    window.loadingPage();
};

let countdownIntervalID;
window.sendOTP = () => {
    window.removeValidate(document.getElementById("verifyOTP"));
    window.eraseCookie("OTP_3");
    window.eraseCookie("REF");
    window.eraseCookie("OTP_10");
    window.stopCountdownInterval();
    document.getElementById("verifyOTP").value = "";
    document.getElementById("verifyOTP").disabled = true;
    document.getElementById("confirmVerifyOTP").disabled = true;
    let alert = document.getElementById("alertVerifyOTP");
    alert.classList.remove("d-none");
    alert.classList.remove("d-block");
    alert.classList.remove("alert-success");
    alert.classList.remove("alert-danger");
    alert.classList.add("d-none");
    let textCountdown = document.getElementById("textCountdown");
    let textResendCode = document.getElementById("textResendCode");
    textCountdown.classList.remove("d-none");
    textCountdown.classList.add("d-inline");
    textResendCode.classList.remove("d-inline");
    textResendCode.classList.add("d-none");
    document.getElementById("otpRef").innerText = "----";
    document.getElementById("countdown").innerText = "--:--";
    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function (data) {
        if (xhr.readyState === 4) {
            const response = JSON.parse(xhr.responseText);
            if (response.status === 500) {
                alert.classList.remove("d-none");
                alert.classList.remove("d-block");
                alert.classList.remove("alert-success");
                alert.classList.remove("alert-danger");
                alert.classList.add("d-block");
                alert.classList.add("alert-danger");
                alert.innerHTML =
                    "We can not send email, please try again later.";
            } else {
                let dateEndThreeMin = window.addDateSeconds(180);
                let dateEndTenMin = window.addDateSeconds(600);
                window.setCookie("OTP_3", dateEndThreeMin, 180);
                window.setCookie("OTP_10", dateEndTenMin, 600);
                if (window.getCookie("OTP_3")) {
                    window.countdown(180); //Count down 3 minutes
                }
                let otpRef = document.getElementById("otpRef");
                setCookie("REF", response.otpRef, 180);
                otpRef.innerText = getCookie("REF");
                document.getElementById("verifyOTP").disabled = false;
                document.getElementById("confirmVerifyOTP").disabled = false;
            }
        }
    };
    xhr.open("POST", "/me/send-otp/");
    xhr.send();
};

window.countdown = (seconds) => {
    window.stopCountdownInterval();
    let minute = seconds / 60;
    let sec = 0;
    document.getElementById("countdown").innerText =
        minute.toString().padStart(2, "0") +
        ":" +
        sec.toString().padStart(2, "0");
    countdownIntervalID = setInterval(function () {
        sec--;
        if (sec === -1) {
            minute--;
            sec = 59;
            if (minute == -1 && sec == 59) {
                let textCountdown = document.getElementById("textCountdown");
                let textResendCode = document.getElementById("textResendCode");
                textCountdown.classList.remove("d-inline");
                textCountdown.classList.add("d-none");
                textResendCode.classList.remove("d-none");
                textResendCode.classList.add("d-inline");

                window.stopCountdownInterval();

                return false;
            }
        }
        document.getElementById("countdown").innerText =
            minute.toString().padStart(2, "0") +
            ":" +
            sec.toString().padStart(2, "0");
    }, 1000);
};

window.stopCountdownInterval = () => {
    if (countdownIntervalID) {
        clearInterval(countdownIntervalID);
    }
};

window.verifyOTP = () => {
    // chceck expire 10 min //
    let dateTimeTenMin = new Date(window.getCookie("OTP_10"));
    let dateNow = new Date();
    if (dateTimeTenMin < dateNow) {
        document.getElementById("verifyOTP").classList.add("is-invalid");
        document
            .getElementById("verifyOTP")
            .parentNode.querySelector(".invalid-feedback").innerText =
            "Your otp code has expired.";
        return false;
    }

    document.getElementById("verifyOTP").disabled = true;
    document.getElementById("confirmVerifyOTP").disabled = true;
    const oldPassword = document.getElementById("oldPassword").value;
    const newPassword = document.getElementById("newPassword").value;
    const verifyOTP = document.getElementById("verifyOTP").value;
    let xhr = new XMLHttpRequest();
    let formData = new FormData();
    formData.append("oldPassword", oldPassword);
    formData.append("newPassword", newPassword);
    formData.append("verifyOTP", verifyOTP);
    xhr.onreadystatechange = function (data) {
        if (xhr.readyState === 4) {
            const response = JSON.parse(xhr.responseText);
            if (response.errors) {
                if (response.errors.verifyOTP) {
                    document
                        .getElementById("verifyOTP")
                        .classList.add("is-invalid");
                    document
                        .getElementById("verifyOTP")
                        .parentNode.querySelector(
                            ".invalid-feedback"
                        ).innerText = response.errors.verifyOTP;
                }
                document.getElementById("verifyOTP").disabled = false;
                document.getElementById("confirmVerifyOTP").disabled = false;
            } else {
                window.openModal("passwordChangedModal", "verifyOTPModal");
            }
            window.loadingPageClose();
        }
    };
    xhr.open("POST", "/me/verify-otp/");
    xhr.send(formData);
    window.loadingPage();
};

window.clearForm = (formId) => {
    document.getElementById(formId).reset();

    window.removeAllValidators(formId);   
};

window.removeAllValidators = (formId) => {
    //Clear All validate in formId
    document.getElementById(formId).querySelectorAll('.is-invalid').forEach((isInValid) => {
        isInValid.classList.remove('is-invalid');
    });     
};

window.addDateSeconds = (seconds) => {
    const currentDate = new Date();
    const futureDate = new Date(currentDate.getTime() + seconds * 1000);
    return futureDate;
};

window.setCookie = (name, value, seconds) => {
    let expires = "";
    if (seconds) {
        let date = new Date();
        date.setTime(date.getTime() + seconds * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

window.getCookie = (name) => {
    let nameEQ = name + "=";
    let cookies = document.cookie.split(";");
    for (let cookie of cookies) {
        let c = cookie;
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

window.eraseCookie = (name) => {
    document.cookie =
        name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

// check existing email
// should set data-route = url
window.checkExistEmail = (e) => {
    const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (!regex.test(e.value)) return;

    const requestOptions = {
        method: "GET",
    };

    const route = e.dataset?.route ?? null;
    const url = route + `/?email=${e.value}`;
    let invalid = document.getElementsByClassName(`invalid-message-${e.name}`);

    fetch(url, requestOptions)
        .then((response) => response.json())
        .then((result) => {
            if (!result.message) return;

            invalid[0].textContent = result.message;
            e.classList.add("is-invalid");
        });
};

window.addEventListener('load', window.loadingPageClose);
window.addEventListener('beforeunload', window.loadingPage);

window.getMultiLanguage = () => {
    const xhr = new XMLHttpRequest()
    xhr.onreadystatechange = function() {
        if (this.readyState !== 4) return
        const data = JSON.parse(this.responseText);

        const multiLanguageSelect = document.getElementsByClassName('multiLanguageSelect');

        for (let i = 0; i < multiLanguageSelect.length; i++) {
            multiLanguageSelect.item(i).querySelector('.input-dropdown').innerHTML = data.default.name;
        }

        let tem = ''
        data.list.forEach(function(value) {
            if (value.language !== data.default.key) {
            tem += `<li><a class="dropdown-item" onclick="changeMultiLanguage('${value.language}', '${value.language_name}');">${value.language_name}</a></li>`;
            }
        })
        for (let i = 0; i < multiLanguageSelect.length; i++) {
            multiLanguageSelect.item(i).querySelector('ul.dropdown-menu').innerHTML = tem;
        }
    }
    xhr.open('GET', '/api/multi-language/list')
    xhr.send()
};

window.addEventListener('load', window.getMultiLanguage);

window.changeMultiLanguage = (langKey, langName) => {
    document.querySelector('.multiLanguageSelect .input-dropdown').innerHTML = langName;

    const xhr = new XMLHttpRequest()
    xhr.onreadystatechange = function() {
        if (this.readyState !== 4) return
        const data = JSON.parse(this.responseText);

        location.reload();
    }
    xhr.open('GET', '/api/multi-language/change/' + langKey)
    xhr.send()
};
